/**
 * QMBSummaryWidget — Dashboard-Kachel für offene QMB-Lesebestätigungen.
 * Blendet sich aus, wenn nichts Offenes vorliegt.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { ShieldCheck, ArrowRight, ClipboardCheck } from 'lucide-react';
import { qmbAPI } from '../../lib/api';

export const QMBSummaryWidget = () => {
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await qmbAPI.dashboardSummary();
      setData(r.data);
    } catch (e) {
      setData(null);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!loaded || !data) return null;
  const unread = data.unread_required || [];
  if (unread.length === 0) return null;

  return (
    <Card className="border-amber-300 bg-amber-50/50 dark:bg-amber-900/10" data-testid="qmb-summary-widget">
      <CardHeader className="border-b border-amber-200/60 pb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <CardTitle className="font-heading text-lg flex flex-wrap items-center gap-2">
          <ShieldCheck className="h-5 w-5 text-amber-600 shrink-0" />
          QMB / Qualitätsmanagement
          <Badge variant="destructive" data-testid="qmb-widget-count">{unread.length} zu bestätigen</Badge>
        </CardTitle>
        <Link to="/qmb" className="shrink-0 self-start sm:self-auto">
          <Button variant="ghost" size="sm" className="text-xs whitespace-nowrap" data-testid="qmb-widget-view-all">
            Zu QMB <ArrowRight className="h-3 w-3 ml-1" />
          </Button>
        </Link>
      </CardHeader>
      <CardContent className="p-4">
        <ul className="space-y-1.5" data-testid="qmb-widget-items">
          {unread.slice(0, 5).map((p) => (
            <li key={p.id}>
              <Link to="/qmb" className="flex items-center gap-2 text-sm border-b border-border/40 pb-1.5 hover:bg-secondary/40 rounded px-1 -mx-1 transition-colors">
                <ClipboardCheck className="h-4 w-4 text-amber-600 shrink-0" />
                <span className="font-medium truncate">{p.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
